// telemetry-sources.ts
// Sources logiques utilisées pour /api/telemetry/errors — convention "backoffice.<domaine>".
// Les sources spécifiques à une fonctionnalité (ex: "backoffice.riskForm") sont
// définies au plus proche de leur appel, pas ici.

export const TELEMETRY_SOURCES = {
  errorBoundary: "backoffice.errorBoundary",
  globalError: "backoffice.globalError",
  unhandledRejection: "backoffice.unhandledRejection",
} as const;
